// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism.css"

export const onServiceWorkerUpdateReady = () => window.location.reload()
